// extracted by mini-css-extract-plugin
export default {"Award":"Award_Award__2WDTT"};